<!--
 * @Author: pluto.guo 66291979@qq.com
 * @Date: 2025-01-16 17:19:43
 * @LastEditors: pluto.guo 66291979@qq.com
 * @LastEditTime: 2025-01-16 17:27:36
 * @FilePath: /lobby/src/components/PersonComponents.vue
 * @Description: 
 * 
 * Copyright (c) 2025 by ${git_name_email}, All Rights Reserved. 
-->
<template>
  <div style="font-size: 0.18rem; color: #00cf34; height: 0.05rem">
    <i class="bi bi-people-fill"></i
    ><span style="color: white; line-height: 0.2rem; opacity: 0.75"
      >&nbsp;{{ formatMoney(person, 0) }}</span
    >
  </div>
</template>

<script>
import { useLobbyStore } from '@/stores/lobby'
import { formatMoney, getRandomIntInclusive } from '@/utils/helper'
import { mapState } from 'pinia'

export default {
  props: {
    game: {}
  },
  data() {
    return {
      isHot: false,
      person: 0
    }
  },
  mounted() {
    if (this.game && this.game.category && this.hotGame) {
      this.isHot = this.game.category.includes(this.hotGame.id)
      this.randomPerson()
    }
  },
  computed: {
    ...mapState(useLobbyStore, ['categories', 'hotGame'])
  },
  methods: {
    formatMoney,
    randomPerson() {
      const now = new Date()
      const hours = now.getHours()
      const minutes = now.getMinutes()
      const isInRange = (hours > 16 || (hours === 16 && minutes >= 30)) && hours < 24
      let initialValue = 0
      const getRandomValue = (min, max, changeMin, changeMax, limitMin, limitMax) => {
        initialValue = initialValue === 0 ? getRandomIntInclusive(min, max) : initialValue
        const changeValue = getRandomIntInclusive(changeMin, changeMax)
        return Math.min(
          Math.max(initialValue + changeValue * [1, -1][getRandomIntInclusive(0, 1)], limitMin),
          limitMax
        )
      }

      const getPersonValue = () => {
        if (isInRange) {
          this.person = this.isHot
            ? getRandomValue(3000, 5000, 5, 20, 2000, 6000)
            : getRandomValue(2000, 3000, 5, 15, 1000, 4000)
        } else {
          this.person = this.isHot
            ? getRandomValue(3000, 5000, 5, 20, 2000, 6000) * 0.6
            : getRandomValue(2000, 3000, 5, 15, 1000, 4000) * 0.6
        }
        initialValue = this.person
      }
      getPersonValue()
      setInterval(() => {
        getPersonValue()
      }, 30000)
    }
  }
}
</script>

<style lang="scss" scoped></style>
